<template>
  <div class="rcc-table-list">
    <div class="rcc-table-list__button-wrapper" v-if="editAccess">
      <rcc-button @click="$router.push({ name: 'detailing-new' })">
        Добавить детализацию
      </rcc-button>
    </div>
    <div class="rcc-table-list__table-wrapper">
      <rcc-table
        :page.sync="page"
        :pageCount="pagesCount"
        :itemsPerPage="rowsOnTable"
        :headers="headers"
        :rows="rows"
        :is-fixed-header="true"
        :isShowFilters="false"
        :isLoading="isDataLoading"
        @filters-changed="handleFiltersChanged"
      />
    </div>
  </div>
</template>

<script>
import Page from '@/mixins/page'
import TableList from '@/mixins/table-list'
import detailingApi from '@/api/detailing'
import headerData from './header'

import RccTable from 'Components/table/rcc-table'
import RccButton from 'Components/controls/rcc-button'

export default {
  mixins: [Page, TableList, detailingApi],

  components: {
    RccTable,
    RccButton
  },

  computed: {
    headerData() {
      return headerData
    }
  },

  methods: {
    loadData(filters) {
      this.isDataLoading = true

      this.getDetails({ page: this.page, per_page: this.rowsOnTable, ...filters })
        .then(({ pages, items }) => {
          if (!pages) {
            this.resetTableData()
            return
          }

          this.pagesCount = pages

          this.rows = items
        })
        .finally(() => { this.isDataLoading = false })
    }
  }
}
</script>
